import {
  Flex,
  FormElement,
  HelpIcon,
  Select,
  SELECT_VARIANT_WITH_CHECKBOX,
  Text,
  TEXT_VARIANT_BOLD,
  Toggle,
  TooltipUtils
} from 'mailup-web-components'
import {
  modalSharedListsState,
  modalSharedListsValidState
} from 'Pages/SourcesList/recoil/state/modals'
import { useEffect } from 'react'

import { useIntl } from 'react-intl'

import { useRecoilValue, useSetRecoilState } from 'recoil'

const InputLists = () => {
  const intl = useIntl()

  useEffect(() => {
    TooltipUtils.rebuild()
  }, [])

  const { lists, copyToLists, selectAll } = useRecoilValue(
    modalSharedListsState
  )

  const validForm = useRecoilValue(modalSharedListsValidState)
  const setModalSharedListsState = useSetRecoilState(modalSharedListsState)

  const handleChangeCopyToLists = (selected) => {
    setModalSharedListsState((prev) => ({
      ...prev,
      copyToLists: selected
    }))
  }

  const handleToggleSelectAll = () => {
    setModalSharedListsState(({ selectAll, ...prev }) => ({
      ...prev,
      selectAll: !selectAll
    }))
  }

  return (
    <>
      <Flex
        width='100%'
        justifyContent='space-between'
        alignItems='center'
        margin='0 0 4px 0'
      >
        <Flex columnGap='4px' height='24px' alignItems='flex-end'>
          <Text variant={TEXT_VARIANT_BOLD}>
            {intl.formatMessage({
              id: 'Load.ContentsSouces.SharedModalDdlLabel'
            })}
          </Text>
          <HelpIcon
            text={intl.formatMessage({
              id: 'Load.ContentsSouces.TooltipShare'
            })}
          />
        </Flex>

        <Flex columnGap='8px'>
          <Toggle
            variant='sm'
            checked={selectAll}
            onChange={handleToggleSelectAll}
            name='select-all'
            value='true'
          />

          <Text htmlFor='input-select-all-true'>
            {intl.formatMessage({
              id: 'Load.ContentsSouces.SharedModalSelectAll'
            })}
          </Text>
        </Flex>
      </Flex>
      <FormElement
        feedback={
          !validForm
            ? intl.formatMessage({
                id: 'Load.ContentsSouces.SharedModalDdlError'
              })
            : undefined
        }
        variant={!validForm ? 'danger' : undefined}
      >
        <Select
          multiple
          variant={SELECT_VARIANT_WITH_CHECKBOX}
          placeholder={intl.formatMessage({
            id: 'Load.ContentsSouces.SharedModalDdlPlaceHolder'
          })}
          options={lists}
          value={copyToLists}
          onChange={handleChangeCopyToLists}
          disabled={selectAll}
          error={!validForm}
        />
      </FormElement>
    </>
  )
}

export default InputLists
